module.exports = __webpack_public_path__ + "static/media/kz.fc427f39.webp";